import { allUserRef , systemAdminNotifyRef, systemAdminEditNotifyRef } from "../config/firebase";
import {
  SYSTEM_ADMIN_FETCH_NOTIFICATIONS,
  SYSTEM_ADMIN_FETCH_NOTIFICATIONS_SUCCESS,
  SYSTEM_ADMIN_FETCH_NOTIFICATIONS_FAILED,
  SYSTEM_ADMIN_EDIT_NOTIFICATIONS,
  SYSTEM_ADMIN_SEND_NOTIFICATION,
  SYSTEM_ADMIN_SEND_NOTIFICATION_SUCCESS,
  SYSTEM_ADMIN_SEND_NOTIFICATION_FAILED,
} from "./types";
import moment from 'moment';
import { store } from "../reducers/store";
//import firebase from 'firebase/app';
import 'firebase/database';
import  languageJson  from "../config/language";
export const fetchSystemAdminNotifications = () => dispatch => {
  dispatch({
    type: SYSTEM_ADMIN_FETCH_NOTIFICATIONS,
    payload: null
  });
  systemAdminNotifyRef.on("value", snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
       
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });

      dispatch({
        type: SYSTEM_ADMIN_FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: SYSTEM_ADMIN_FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const editSystemAdminNotifications = (notifications, method) => dispatch => {
  
  notifications.sentDateTime = moment().format('M-d-Y h:m:s');
 
  dispatch({
    type: SYSTEM_ADMIN_EDIT_NOTIFICATIONS,
    payload: { method, notifications }
  });
  let contractData = store.getState().contractsdata.contracts;
  let accountData = store.getState().accountsdata.accounts;
  if(contractData.filter( d => d.id === notifications.contractId).length !== 0 ){
    notifications.members = contractData.filter( d => d.id === notifications.contractId)[0]['members'];
  }
  if(accountData.filter(d =>  d.id === notifications.accountId).length !== 0){
      let allUsers = {};
      let users = accountData.filter( d => d.id === notifications.accountId)[0]['users'];
      for(let key in users){
        if(users[key] === 'Admin')
         allUsers[key] = 'Admin';
      }
      notifications.adminUsers = allUsers; 
  }
  if(method === 'Add' ){
    systemAdminNotifyRef.push(notifications);
  }else if(method === 'Delete'){
    systemAdminEditNotifyRef(notifications.id).remove();
  }else{
    systemAdminEditNotifyRef(notifications.id).set(notifications);
  }
}

export const sendSystemAdminNotification = (notification) => dispatch => {
  dispatch({
    type: SYSTEM_ADMIN_SEND_NOTIFICATION,
    payload: notification
  });

  let users = store.getState().usersdata.users;
  let arr = [];
  for (let i = 0; i < users.length; i++) {
    let usr = users[i];
    let obj = {
      to: null,
      title: notification.title,
      body: notification.body,
      "data": { "msg": notification.body, "title": notification.title },
      priority: "high",
      sound: "default",
      badge: '0'
    };
    if(notification.type === 'Global'){
      if (usr.pushToken) {
        obj.to = usr.pushToken;
        arr.push(obj);
      }
    } else if(notification.type === 'NonGlobal'){
      return false;
    } else if (notification.usertype === 'All' && notification.devicetype === 'All') {
      if (usr.pushToken) {
        obj.to = usr.pushToken;
        arr.push(obj);
      }
    } else if (notification.usertype === 'All' && notification.devicetype !== 'All') {
      if (usr.pushToken && usr.userPlatform === notification.devicetype) {
        obj.to = usr.pushToken;
        arr.push(obj);
      }
    } else if (notification.usertype !== 'All' && notification.devicetype === 'All') {
      if (usr.pushToken && usr.usertype === notification.usertype) {
        obj.to = usr.pushToken;
        arr.push(obj);
      }
    } else {
      if (usr.pushToken && usr.usertype === notification.usertype && usr.userPlatform === notification.devicetype) {
        obj.to = usr.pushToken;
        arr.push(obj);
      }
    }
  }

  if (arr.length > 0) {
    fetch('https://exp.host/--/api/v2/push/send', {
      mode: 'no-cors',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(arr),
    }).then((responseJson) => {
      dispatch({
        type: SYSTEM_ADMIN_SEND_NOTIFICATION_SUCCESS,
        payload: responseJson
      });
      alert(arr.length + languageJson.notification_sent);
    })
      .catch((error) => {
        dispatch({
          type: SYSTEM_ADMIN_SEND_NOTIFICATION_FAILED,
          payload: error,
        });
        alert(languageJson.notification_sent_failed);
      });
  } else {
    dispatch({
      type: SYSTEM_ADMIN_SEND_NOTIFICATION_FAILED,
      payload: languageJson.no_user_match,
    });
    alert(languageJson.no_user_matching);
  }
}
